// src/utils/Markdown.jsx
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Box, Link as MuiLink } from "@mui/material";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { prism } from "react-syntax-highlighter/dist/esm/styles/prism";
import {
  prismDark,
  okaidia,
  vscDarkPlus,
  coy,
  solarizedlight,
} from "react-syntax-highlighter/dist/esm/styles/prism";

export default function Markdown({ text }) {  
  return (
    <Box
      sx={{
        "& h1,& h2,& h3": { mt: 2, mb: 1, fontWeight: 600 },
        "& p": { my: 1 },
        "& ul, & ol": { pl: 3, my: 1 },
        "& code": {
          px: 0.5,
          py: 0.25,
          borderRadius: 1,
          // bgcolor: "grey.100",
          fontFamily:
            "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
        },
        "& pre": {
          p: 1.5,
          borderRadius: 2,
          // bgcolor: "grey.100",
          overflow: "auto",
        },
        "& img": {
         width: "100%",
        },
        "& table": { borderCollapse: "collapse", my: 1 },
        "& th, & td": { border: "1px solid", borderColor: "divider", p: 1 },
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node, ...props }) => (
            <MuiLink {...props} target="_blank" rel="noopener noreferrer" />
          ),
          code({ inline, className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || "");
            if (!inline && match) {
              return (
                <SyntaxHighlighter
                  language={match[1]}
                  PreTag="div"
                  style={vscDarkPlus}
                  {...props}
                >
                  {String(children).replace(/\n$/, "")}
                </SyntaxHighlighter>
              );
            }
            return (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
        }}
      >
        {text}
      </ReactMarkdown>
    </Box>
  );
}
